export default "__VITE_ASSET__wNC5kZTG__"